import vanillaAxios, { AxiosRequestConfig } from 'axios'
import { getAuth } from 'firebase/auth'
import app from '../firebase/initialize'

const auth = getAuth(app)

const axios = vanillaAxios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-web-app-version': '1.0.0',
  },
})

// Auth header

axios.interceptors.request.use(async (config: AxiosRequestConfig<any>) => {
  const token = await auth.currentUser?.getIdToken()

  if (!token) {
    return config
  }

  config.headers!.authorization = `Bearer ${token}`

  return config
})

export default axios
